import { useEffect, useState } from 'preact/hooks';
import { activeCard, cardList, ui } from '../state/store';
import { deleteCard, newCard, openCard } from '../state/actions';
import { languageInfo } from '../languages';
import { timeAgo } from '../util/time';
import { IconCheck, IconPlus, IconSearch, IconTrash, IconX } from './Icons';

export function Sidebar() {
  const cards = cardList.value;
  const active = activeCard.value?.id;
  const [query, setQuery] = useState('');
  const [confirming, setConfirming] = useState<string | null>(null);
  const [, tick] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => tick((n) => n + 1), 60_000);
    return () => clearInterval(timer);
  }, []);

  const q = query.trim().toLowerCase();
  const filtered = q ? cards.filter((c) => c.title.toLowerCase().includes(q) || languageInfo(c.language).label.toLowerCase().includes(q)) : cards;

  return (
    <aside class="sidebar" aria-label="Cards" aria-hidden={!ui.value.sidebarOpen}>
      <div class="sidebar-header">
        <h2>Cards</h2>
        <button type="button" class="button primary small" onClick={() => void newCard()} title="New card (Alt+N)">
          <IconPlus size={16} /> New card
        </button>
      </div>
      <label class="search">
        <IconSearch size={16} />
        <input type="search" placeholder="Search cards" aria-label="Search cards" value={query} onInput={(e) => setQuery((e.target as HTMLInputElement).value)} />
      </label>
      <ul class="card-list">
        {filtered.length === 0 && <li class="card-list-empty">{query ? 'No cards match.' : 'No cards yet.'}</li>}
        {filtered.map((card) => (
          <li key={card.id} class={`card-item${card.id === active ? ' active' : ''}`}>
            <button type="button" class="card-item-main" aria-current={card.id === active ? 'true' : undefined} onClick={() => void openCard(card.id)}>
              <span class="card-item-title">{card.title}</span>
              <span class="card-item-meta">
                <span>{languageInfo(card.language).label}</span>
                <span>{timeAgo(card.updatedAt)}</span>
              </span>
            </button>
            {confirming === card.id ? (
              <span class="confirm-delete">
                <button
                  type="button"
                  class="icon-button danger"
                  title="Delete this card"
                  aria-label="Confirm delete"
                  onClick={() => {
                    setConfirming(null);
                    void deleteCard(card.id);
                  }}
                >
                  <IconCheck size={16} />
                </button>
                <button type="button" class="icon-button" title="Keep it" aria-label="Cancel delete" onClick={() => setConfirming(null)}>
                  <IconX size={16} />
                </button>
              </span>
            ) : (
              <button type="button" class="icon-button subtle delete" title="Delete card" aria-label={`Delete card ${card.title}`} onClick={() => setConfirming(card.id)}>
                <IconTrash size={16} />
              </button>
            )}
          </li>
        ))}
      </ul>
    </aside>
  );
}
